/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2024
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import StringUtils from './StringUtils';
import BaseMoserObject from './BaseMoserObject';
import CaseInsensitiveMap from './CaseInsensitiveMap';
import V5QueryExpressionParserTokenValidator from './V5QueryExpressionParserTokenValidator';
//@import StringUtils (runtime) // inlined method
//@import BaseMoserObject (loadtime) // superclass
//@import CaseInsensitiveMap (runtime) // new
//@import com/ibm/bi/platform/moser/common/utils/V5QueryExpressionParserTokenValidator (static) // isLetterOrDigit, isLetter

export default class IdentifierUtil extends BaseMoserObject{

	/**
	 * from V5ValueSummaryFunction
	 */
	static V5_AGGREGATE = "AGGREGATE";

	static V5_AVERAGE = "AVERAGE";

	static V5_COUNT = "COUNT";

	static V5_MAXIMUM = "MAXIMUM";

	static V5_MEDIAN = "MEDIAN";

	static V5_MINIMUM = "MINIMUM";

	static V5_STDDEV = "STANDARD-DEVIATION";

	static V5_STDDEVPOP = "STANDARD-DEVIATION-POP";

	static V5_TOTAL = "TOTAL";

	static V5_VARIANCE = "VARIANCE";

	static V5_VARIANCEPOP = "VARIANCE-POP";

	/**
	 * from V5ValueAnalyticFunction
	 */
	static V5_FIRST = "FIRST";

	static V5_LAST = "LAST";

	static V5_RANK = "RANK";

	static V5_PERCENTAGE = "PERCENTAGE";

	static V5_PERCENTILE = "PERCENTILE";

	static V5_QUANTILE = "QUANTILE";

	static V5_QUARTILE = "QUARTILE";

	static V5_TERTILE = "TERTILE";

	/**
	 * from V5MovingAndRunningSummaryFunction
	 */
	static V5_MOVING_AVERAGE = "MOVING-AVERAGE";

	static V5_MOVING_TOTAL = "MOVING-TOTAL";

	static V5_RUNNING_AVERAGE = "RUNNING-AVERAGE";

	static V5_RUNNING_COUNT = "RUNNING-COUNT";

	static V5_RUNNING_DIFFERENCE = "RUNNING-DIFFERENCE";

	static V5_RUNNING_MAX = "RUNNING-MAXIMUM";

	static V5_RUNNING_MIN = "RUNNING-MINIMUM";

	static V5_RUNNING_TOTAL = "RUNNING-TOTAL";

	/**
	 * V5 Aggregate functions.
	 */
	static V5_AGGREGAETS = ["AGGREGATE", "AVERAGE", "COUNT", "MAXIMUM", "MEDIAN", "MINIMUM", "STANDARD-DEVIATION", "STANDARD-DEVIATION-POP", "TOTAL", "VARIANCE", "VARIANCE-POP", "FIRST", "LAST", "RANK", "PERCENTAGE", "PERCENTILE", "QUANTILE", "QUARTILE", "TERTILE", "MOVING-AVERAGE", "MOVING-TOTAL", "RUNNING-AVERAGE", "RUNNING-COUNT", "RUNNING-DIFFERENCE", "RUNNING-MAXIMUM", "RUNNING-MINIMUM", "RUNNING-TOTAL"];

	/**
	 * Static array of reserved SQL keywords. This is the SQL99 reserved word list from the spec (section 5.2): Copied from RQPSqlKeyword.java
	 */
	static RESERVED_KEYWORDS = ["ABSOLUTE", "ACTION", "ADD", "ADMIN", "AFTER", "AGGREGATE", "ALIAS", "ALL", "ALLOCATE", "ALTER", "AND", "ANY", "ARE", "ARRAY", "AS", "ASC", "ASSERTION", "AT", "AUTO", "AUTHORIZATION", "BEFORE", "BEGIN", "BETWEEN", "BINARY", "BIT", "BLOB", "BOOLEAN", "BOTH", "BREADTH", "BY", "CALL", "CASCADE", "CASCADED", "CASE", "CAST", "CATALOG", "CHAR", "CHARACTER", "CHECK", "CLASS", "CLOB", "CLOSE", "COLLATE", "COLLATION", "COLUMN", "COMMIT", "COMPLETION", "CONNECT", "CONNECTION", "CONSTRAINT", "CONSTRAINTS", "CONSTRUCTOR", "CONTAINS", "CONTINUE", "CORRESPONDING", "CREATE", "CROSS", "CUBE", "CURRENT", "CURRENT_DATE", "CURRENT_PATH", "CURRENT_ROLE", "CURRENT_TIME", "CURRENT_TIMESTAMP", "CURRENT_USER", "CURRENTMEASURE", "CURSOR", "CYCLE", "DATA", "DATE", "DAY", "DEALLOCATE", "DEC", "DECIMAL", "DECLARE", "DEFAULT", "DEFERRABLE", "DEFERRED", "DELETE", "DEPTH", "DEREF", "DESC", "DESCRIBE", "DESCRIPTOR", "DESTROY", "DESTRUCTOR", "DETERMINISTIC", "DICTIONARY", "DIAGNOSTICS", "DISCONNECT", "DISTINCT", "DOMAIN", "DOUBLE", "DROP", "DYNAMIC", "EACH", "ELSE", "END", "ENDS", "END-EXEC", "EQUALS", "ESCAPE", "EVERY", "EXCEPT", "EXCEPTION", "EXEC", "EXECUTE", "EXTERNAL", "FALSE", "FETCH", "FIRST", "FLOAT", "FOR", "FOREIGN", "FOUND", "FROM", "FREE", "FULL", "FUNCTION", "GENERAL", "GET", "GLOBAL", "GO", "GOTO", "GRANT", "GROUP", "GROUPING", "HAVING", "HOST", "HOUR", "IDENTITY", "IF", "IGNORE", "IMMEDIATE", "IN", "IN_RANGE", "INDICATOR", "INITIALIZE", "INITIALLY", "INNER", "INOUT", "INPUT", "INSERT", "INT", "INTEGER", "INTERSECT", "INTERVAL", "INTO", "IS", "ISOLATION", "ITERATE", "JOIN", "KEY", "LANGUAGE", "LARGE", "LAST", "LATERAL", "LEADING", "LEFT", "LESS", "LEVEL", "LIKE", "LIMIT", "LOCAL", "LOCALTIME", "LOCALTIMESTAMP", "LOCATOR", "LOOKUP", "MAP", "MATCH", "MINUTE", "MISSING", "MODIFIES", "MODIFY", "MODULE", "MONTH", "MOVING", "NAMES", "NATIONAL", "NATURAL", "NCHAR", "NCLOB", "NEW", "NEXT", "NO", "NONE", "NOT", "NULL", "NUMBER", "NUMERIC", "OBJECT", "OF", "OFF", "OLD", "ON", "ONLY", "OPEN", "OPERATION", "OPTION", "OR", "ORDER", "ORDINALITY", "OUT", "OUTER", "OUTPUT", "PAD", "PARAMETER", "PARAMETERS", "PARTIAL", "PATH", "POSTFIX", "PRECISION", "PREFIX", "PREFILTER", "PREORDER", "PREPARE", "PRESERVE", "PRIMARY", "PRIOR", "PRIVILEGES", "PROCEDURE", "PUBLIC", "READ", "READS", "REAL", "RECURSIVE", "REF", "REFERENCES", "REFERENCING", "RELATIVE", "REPORT", "RESTRICT", "RESULT", "RETURN", "RETURNS", "REVOKE", "RIGHT", "ROLE", "ROLLBACK", "ROLLUP", "ROUTINE", "ROW", "ROWS", "RUNNING", "SAVEPOINT", "SCHEMA", "SCROLL", "SCOPE", "SEARCH", "SECOND", "SECTION", "SELECT", "SEQUENCE", "SESSION", "SESSION_USER", "SET", "SETS", "SIZE", "SMALLINT", "SOME", "SPACE", "SPECIFIC", "SPECIFICTYPE", "SQL", "SQLEXCEPTION", "SQLSTATE", "SQLWARNING", "START", "STARTS", "STATE", "STATEMENT", "STATIC", "STRING", "STRUCTURE", "SYSTEM_USER", "TABLE", "TEMPORARY", "TERMINATE", "THAN", "THEN", "TIME", "TIMESTAMP", "TIMEZONE_HOUR", "TIMEZONE_MINUTE", "TO", "TRAILING", "TRANSACTION", "TRANSLATION", "TREAT", "TRIGGER", "TRUE", "UNDER", "UNION", "UNIQUE", "UNKNOWN", "UNNEST", "UPDATE", "USAGE", "USER", "USING", "VALUE", "VALUES", "VARCHAR", "VARIABLE", "VARYING", "VIEW", "WHEN", "WHENEVER", "WHERE", "WITH", "WITHOUT", "WORK", "WRITE", "YEAR", "ZONE"];

	/**
	 * Static array of SQL keywords. Copied from RQPSqlKeyword.java
	 */
	static KEYWORDS = ["as", "at", "by", "in", "is", "ln", "no", "of", "on", "or", "to", "abs", "all", "and", "any", "asc", "avg", "day", "dec", "end", "exp", "for", "int", "max", "min", "mod", "not", "out", "row", "set", "sum", "top", "both", "call", "case", "cast", "ceil", "char", "cube", "date", "desc", "else", "from", "full", "hour", "into", "join", "last", "left", "like", "null", "over", "perc", "rank", "ravg", "real", "rmax", "rmin", "rsum", "rows", "sets", "some", "sqrt", "then", "time", "trim", "true", "user", "when", "with", "xavg", "xmax", "xmin", "xsum", "year", "zone", "count", "cross", "dbkey", "false", "first", "float", "floor", "group", "inner", "local", "lower", "month", "nchar", "ntile", "nulls", "order", "outer", "power", "range", "rdiff", "right", "table", "union", "upper", "using", "where", "xlast", "xperc", "xrank", "_local", "bigint", "cursor", "create", "delete", "double", "escape", "except", "exists", "filter", "having", "insert", "minute", "nullif", "others", "rcount", "rollup", "scroll", "second", "select", "stddev", "update", "values", "window", "within", "xcount", "xfirst", "xratio", "xntile", "_cursor", "_rowset", "between", "boolean", "ceiling", "current", "decimal", "declare", "extract", "integer", "leading", "natural", "numeric", "qualify", "tertile", "unknown", "varchar", "varying", "var_pop", "without", "xstddev", "coalesce", "distinct", "filename", "grouping", "interval", "national", "nvarchar", "position", "smallint", "snapshot", "trailing", "variance", "var_samp", "xtertile", "character", "cume_dist", "intersect", "following", "localtime", "partition", "precision", "preceding", "prefilter", "recursive", "returning", "substring", "timestamp", "updatable", "unbounded", "xvariance", "bit_length", "dense_rank", "last_value", "percentile", "row_number", "stddev_pop", "xmovingavg", "xmovingsum", "char_length", "first_value", "stddev_samp", "xstddev_pop", "current_date", "current_time", "octet_length", "percent_rank", "timezone_hour", "xvariance_pop", "localtimestamp", "percentile_cont", "percentile_disc", "ratio_to_report", "timezone_minute", "character_length", "current_timestamp"];

	static PARSER_KEYWORDS = ["_ADDMEMBERTOSET", "_FORMAT", "AFTER", "AGGREGATE", "AND", "ALL", "ANY", "AS", "ASC", "AT", "AUTO", "AVERAGE", "BASC", "BDESC", "BEFORE", "BEFOREWITHMEMBER", "BETWEEN", "BOTH", "BY", "CASE", "CAST", "CONTAINS", "CORR", "COUNT", "COVARIANCE-POP", "COVARIANCE-SAMP", "CURRENT_DATE", "CURRENTMEASURE", "CURRENT_TIME", "CURRENT_TIMESTAMP", "DEFAULT", "DECOMPOSABLE", "DESC", "DESCENDANTS", "DETAIL", "DISTINCT", "ELSE", "EMPTY", "END", "ENDS", "EQUALS", "ESCAPE", "EXCEPT", "EXTRACT", "FIRST", "FLAG", "FOR", "FROM", "GENERATE", "HIERARCHIZE", "IF", "IMMEDIATELY", "IN", "INTERSECT", "INTERVAL", "IS", "JSON_EXISTS", "JSON_QUERY", "JSON_VALUE", "LAST", "LEADING", "LIKE", "LOCALTIME", "LOCALTIMESTAMP", "LOOKUP", "MAXIMUM", "MEDIAN", "MEMBER", "MINIMUM", "MISSING", "MOVING-AVERAGE", "MOVING-TOTAL", "NOT", "NULL", "NULLS", "OCCURRENCE", "OCCURRENCES_REGEX", "ON", "OR", "ORDER", "OVER", "OVERLAPS", "PARTITION", "PASSING", "PERCENTAGE", "PERCENTAGE_0", "PERCENTAGE_1", "PERCENTAGE_2", "PERCENTILE", "PERIOD", "POSITION", "POSITION_REGEX", "POST", "PRECEDES", "PREFILTER", "QUARTILE", "QUANTILE", "RANK", "REGRESSION-AVERAGE-X", "REGRESSION-AVERAGE-Y", "REGRESSION-COUNT", "REGRESSION-INTERCEPT", "REGRESSION-R2", "REGRESSION-SLOPE", "REGRESSION-SXX", "REGRESSION-SXY", "REGRESSION-SYY", "REPORT", "ROW", "ROWS", "RUNNING-AVERAGE", "RUNNING-COUNT", "RUNNING-DIFFERENCE", "RUNNING-MAXIMUM", "RUNNING-MINIMUM", "RUNNING-TOTAL", "SELF", "SET", "START", "STARTS", "STANDARD-DEVIATION", "STANDARD-DEVIATION-POP", "STANDARD-DEVIATION-SAMP", "SUBSTRING", "SUBSTRINGR", "SUBSTRING_REGEX", "SUCCEEDS", "TERTILE", "THEN", "TIMEZONE_HOUR", "TIMEZONE_MINUTE", "TO", "TOTAL", "TO_JSON", "TRAILING", "TRIM", "TUPLE", "UNION", "VARIANCE", "VARIANCE-POP", "VARIANCE-SAMP", "WHEN", "WIDTH-BUCKET", "WITH", "WITHIN", "XMLQUERY", "XMLEXISTS", "BIT", "BIGINT", "CHAR", "CHARACTER", "DATE", "DAY", "DAYS", "DEC", "DECIMAL", "DOUBLE", "FLOAT", "HOUR", "HOURS", "INT", "INTEGER", "MINUTE", "MINUTES", "MONTH", "MONTHS", "NATIONAL", "NCHAR", "NUMERIC", "NVARCHAR", "PRECISION", "REAL", "SECOND", "SECONDS", "SMALLINT", "TIME", "TIMESTAMP", "VARCHAR", "VARYING", "YEAR", "YEARS", "ZONE"];

	static UNDERSCORE = 95;

	static OPEN_BRACKET = 91;

	static CLOSE_BRACKET = 93;

	/**
	 * Singleton static instance.
	 */
	static instance = new IdentifierUtil();

	/**
	 * Set of SQL keywords. Before keys are added to the map or compared to other existing keys, they are converted to all lowercase in a locale-independent fashion by using information from the Unicode data file. Don't use String.toLowercase() because it depends on default locale.
	 */
	keywordSet = null;

	hyphenatedKeywordSet = null;

	v5AggregateSet = null;



	/**
	 * Constructor.
	 */
	constructor() {
		super();
		this.keywordSet = new CaseInsensitiveMap();
		this.hyphenatedKeywordSet = new CaseInsensitiveMap();
		this.v5AggregateSet = new CaseInsensitiveMap();
		for (var __i_enFor0 = 0, __exp_enFor0 = IdentifierUtil.KEYWORDS, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var keyword = __exp_enFor0[__i_enFor0];
			this.keywordSet.put(keyword, Boolean["TRUE"]);
		}
		for (var __i_enFor1 = 0, __exp_enFor1 = IdentifierUtil.RESERVED_KEYWORDS, __len_enFor1 = __exp_enFor1.length;
				__i_enFor1 < __len_enFor1; ++__i_enFor1) {
			var keyword = __exp_enFor1[__i_enFor1];
			this.keywordSet.put(keyword, Boolean["TRUE"]);
		}
		for (var __i_enFor2 = 0, __exp_enFor2 = IdentifierUtil.PARSER_KEYWORDS, __len_enFor2 = __exp_enFor2.length;
				__i_enFor2 < __len_enFor2; ++__i_enFor2) {
			var keyword = __exp_enFor2[__i_enFor2];
			this.keywordSet.put(keyword, Boolean["TRUE"]);
		}
		for (var __i_enFor3 = 0, __exp_enFor3 = IdentifierUtil.PARSER_KEYWORDS, __len_enFor3 = __exp_enFor3.length;
				__i_enFor3 < __len_enFor3; ++__i_enFor3) {
			var keyword = __exp_enFor3[__i_enFor3];
			var pos = 0;
			var length = keyword.length;
			while (pos < length) {
				var c = keyword.codePointAt(pos);
				if (c == 45) {
					this.hyphenatedKeywordSet.put(keyword, Boolean["TRUE"]);
					break;
				}
				pos++;
			}
		}
		for (var __i_enFor4 = 0, __exp_enFor4 = IdentifierUtil.V5_AGGREGAETS, __len_enFor4 = __exp_enFor4.length;
				__i_enFor4 < __len_enFor4; ++__i_enFor4) {
			var keyword = __exp_enFor4[__i_enFor4];
			this.v5AggregateSet.put(keyword, Boolean["TRUE"]);
		}
	}

	/**
	 * make a unique and valid identifier.
	 * @param {String} name  name.
	 * @param {CaseInsensitiveMap} seenMap  seen ids. case insensitive.
	 * @return {String}  unique and valid identifier.
	 */
	static makeUniqueAndValidIdentifier(name, seenMap) {
		var newId = IdentifierUtil._makeValidIdentifier(name);
		newId = IdentifierUtil._removeExcessUnderscoresOneId(newId);
		newId = IdentifierUtil._changeIdentifierMatchingKeywords(newId);
		newId = IdentifierUtil._resolveNameConflictsOneId(newId, seenMap);
		return newId;
	}

	static isIdValid(idToCheck) {
		if (idToCheck == null || idToCheck.length === 0) {
			return false;
		}
		var firstChar = idToCheck.codePointAt(0);
		if (!(IdentifierUtil._isValidFirstCharacterForGeneration(firstChar))) {
			return false;
		}
		var characters = StringUtils.getCodePoints(idToCheck);
		var it = characters.iterator();
		while (it.hasNext()) {
			var codePoint = it.nextInt();
			var valid = IdentifierUtil._isValidInbetweenCharForGeneration(codePoint);
			if (!valid) {
				return false;
			}
		}
		return !(IdentifierUtil.isKeyword(idToCheck));
	}

	/**
	 * Verifies if the passed in string is a SQL keyword or reserved SQL keyword.
	 * @param {String} str  = String to test
	 * @return {boolean}  boolean result
	 */
	static isKeyword(str) {
		return IdentifierUtil.instance.keywordSet.containsKey(str);
	}

	static convertToValidUniqueIdentifiers(input) {
		var validIdentifiers = [];
		if (!(IdentifierUtil._copyValidIdentifiers(input, validIdentifiers))) {
			IdentifierUtil._makeValidIdentifiers(input, validIdentifiers);
		}
		IdentifierUtil._removeExcessUnderscores(validIdentifiers);
		IdentifierUtil._changeIdentifiersMatchingKeywords(validIdentifiers);
		IdentifierUtil._resolveNameConflicts(validIdentifiers);
		return validIdentifiers;
	}

	static _changeIdentifierMatchingKeywords(validId) {
		return IdentifierUtil.isKeyword(validId) ? validId + "_" : validId;
	}

	static _changeIdentifiersMatchingKeywords(validIdentifiers) {
		for (var i = 0; i < validIdentifiers.length; ++i) {
			validIdentifiers[i] = IdentifierUtil._changeIdentifierMatchingKeywords(validIdentifiers[i]);
		}
	}

	static _removeExcessUnderscoresOneId(validId) {
		var result = IdentifierUtil._removeSequencesOfUnderscores(validId);
		return result.length == 1 ? result : result.replace(new RegExp("_+$","g"), "");
	}

	static _removeExcessUnderscores(validIdentifiers) {
		for (var i = 0; i < validIdentifiers.length; ++i) {
			validIdentifiers[i] = IdentifierUtil._removeExcessUnderscoresOneId(validIdentifiers[i]);
		}
	}

	static _removeSequencesOfUnderscores(identifier) {
		return identifier.replace(new RegExp("__+","g"), "_");
	}

	static _resolveNameConflictsOneId(validId, uniqueIds) {
		var iSuffix = 0;
		var identifier = validId;
		while (uniqueIds.containsKey(identifier)) {
			identifier = validId.charCodeAt(validId.length - 1) == 95 ? validId + ++iSuffix : validId + '_' + ++iSuffix;
		}
		return identifier;
	}

	static _resolveNameConflicts(validIdentifiers) {
		var uniqueIds = new CaseInsensitiveMap();
		for (var i = 0; i < validIdentifiers.length; ++i) {
			validIdentifiers[i] = IdentifierUtil._resolveNameConflictsOneId(validIdentifiers[i], uniqueIds);
			uniqueIds.put(validIdentifiers[i], Boolean["TRUE"]);
		}
	}

	static _makeValidIdentifiers(input, validIdentifiers) {
		for (var i = 0; i < input.length; ++i) {
			if (validIdentifiers[i] != null) {
				continue;
			}
			validIdentifiers[i] = IdentifierUtil._makeValidIdentifier(input[i]);
		}
	}

	static _makeValidIdentifier(identifier) {
		var characters = StringUtils.getCodePoints(identifier);
		var it = characters.iterator();
		var sb = "";
		var firstChar = identifier.codePointAt(0);
		if (!(IdentifierUtil._isValidFirstCharacterForGeneration(firstChar))) {
			sb+=("i");
		}
		while (it.hasNext()) {
			var codePoint = it.nextInt();
			var valid = IdentifierUtil._isValidInbetweenCharForGeneration(codePoint);
			if (!valid) {
				sb+=("_");
			} else {
				sb+=StringUtils.fromCodePoint(codePoint);
			}
		}
		return sb;
	}

	static _copyValidIdentifiers(input, validIdentifiers) {
		var allValid = true;
		for (var i = 0; i < input.length; ++i) {
			var identifier = input[i];
			if (!(IdentifierUtil.isValidIdentifier(identifier))) {
				allValid = false;
			} else {
				validIdentifiers[i] = identifier;
			}
		}
		return allValid;
	}

	static _isValidFirstLastCharacterForValidation(firstChar, lastChar) {
		if (firstChar == 91 && lastChar == 93) {
			return true;
		}
		return IdentifierUtil._isValidFirstCharacterForGeneration(firstChar);
	}

	static _isValidFirstCharacterForGeneration(firstChar) {
		return V5QueryExpressionParserTokenValidator.isLetter(firstChar) || firstChar == 95;
	}

	static _isValidInbetweenCharForValidation(codePoint, firstChar, lastChar) {
		if (firstChar == 91 && lastChar == 93) {
			return true;
		}
		return IdentifierUtil._isValidInbetweenCharForGeneration(codePoint);
	}

	static _isValidInbetweenCharForGeneration(codePoint) {
		return V5QueryExpressionParserTokenValidator.isLetterOrDigit(codePoint) || codePoint == 95;
	}

	static isValidIdentifier(identifier) {
		if (identifier == null || identifier.length === 0) {
			return false;
		}
		var characters = StringUtils.getCodePoints(identifier);
		var it = characters.iterator();
		var firstChar = identifier.codePointAt(0);
		if (!(IdentifierUtil._isValidFirstCharacterForGeneration(firstChar))) {
			return false;
		}
		while (it.hasNext()) {
			var codePoint = it.nextInt();
			if (!(IdentifierUtil._isValidInbetweenCharForGeneration(codePoint))) {
				return false;
			}
		}
		return true;
	}

	static isValidIdentifierForValidation(identifier) {
		if (identifier == null || identifier.length === 0) {
			return false;
		}
		var characters = StringUtils.getCodePoints(identifier);
		var it = characters.iterator();
		var last = identifier.length - 1;
		var firstChar = identifier.codePointAt(0);
		var lastChar = identifier.codePointAt(last);
		if (!(IdentifierUtil._isValidFirstLastCharacterForValidation(firstChar, lastChar))) {
			return false;
		}
		while (it.hasNext()) {
			var codePoint = it.nextInt();
			if (!(IdentifierUtil._isValidInbetweenCharForValidation(codePoint, firstChar, lastChar))) {
				return false;
			}
		}
		return true;
	}

	/**
	 * @param {String} str
	 * @return {boolean}
	 */
	static isHyphenatedKeyword(str) {
		return IdentifierUtil.instance.hyphenatedKeywordSet.containsKey(str);
	}

	static isV5Aggregate(str) {
		return IdentifierUtil.instance.v5AggregateSet.containsKey(str);
	}
}


// WEBPACK FOOTER //
// ./src/generated/IdentifierUtil.js